<template lang="pug" src="./hero.pug"></template>

<script>
import BgVideo from 'components/custom/custom-bg-video/custom-bg-video'
export default {
  props: ['props'],
  components: {
    BgVideo
  },
  methods: {
    btnFunc (i) {
      if (i === '1') {
        this.$router.push('contact')
        this.$store.dispatch('VIEW_TYPES', 1)
      }
    }
  },
  name: 'carrousel',
  data () {
    return {
      swiperOption: {
        autoplay: true,
        loop: true,
        speed: 550
      }
    }
  },
  computed: {
    swiper () {
      return this.$refs.mySwiper.swiper
    }
  }
}
</script>



// WEBPACK FOOTER //
// hero.vue?afdb380a